/**
 * Estados de carregamento/erro/not-ready da tela de laudo (E9.F2.T10). // ux-neutrality:allow doc-comment
 *
 * Extraído de `LaudoCasoPage.tsx` para respeitar limite de 400 linhas. // ux-neutrality:allow doc-comment
 *
 * E54.F8.T09: os três estados falam a linguagem do pacote — eyebrow, título // ux-neutrality:allow doc-comment
 * display e a mensagem dentro de um objeto de blueprint, com a saída no // ux-neutrality:allow doc-comment
 * `Button` do sistema. Antes eram `<h1>`/`<p>`/`<button>` sem classe nenhuma, // ux-neutrality:allow doc-comment
 * herdando o que a folha desse. // ux-neutrality:allow doc-comment
 */
import { LaudoSkeleton } from '@/components/skeletons';
import { Blueprint, Button, CardKicker } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

interface BackProps {
  onBack: () => void;
}

function StateHeader(): JSX.Element {
  return (
    <header>
      <p className="mb-1.5 font-titulo text-rotulo uppercase text-fg-dim">
        {ptBR.laudoCaso.headerEyebrow}
      </p>
      <h1 className="text-display-md text-fg">{ptBR.laudoCaso.pageTitle}</h1>
    </header>
  );
}

export function LoadingState(): JSX.Element {
  return (
    <article className="laudo-page flex flex-col gap-sc-4" data-testid="laudo-loading">
      <span className="sr-only" role="status">
        {ptBR.laudoCaso.loading}
      </span>
      <LaudoSkeleton />
    </article>
  );
}

export function LoadErrorState({ message, onBack }: { message: string } & BackProps): JSX.Element {
  return (
    <article className="laudo-page flex flex-col gap-sc-4" data-testid="laudo-load-error">
      <StateHeader />
      <Blueprint as="section" role="alert" className="flex flex-col items-start gap-sc-3 p-sc-6">
        <p className="text-body-sm text-fg-muted">{message}</p>
        <Button type="button" variant="secondary" size="sm" onClick={onBack}>
          {ptBR.laudoCaso.backToWorkspace}
        </Button>
      </Blueprint>
    </article>
  );
}

export function NotReadyState({ onBack }: BackProps): JSX.Element {
  return (
    <article className="laudo-page flex flex-col gap-sc-4" data-testid="laudo-not-ready">
      <StateHeader />
      <Blueprint
        as="section"
        role="alert"
        className="laudo-not-ready flex flex-col items-start gap-sc-3 p-sc-6"
      >
        <CardKicker className="block">{ptBR.laudoCaso.notReadyKicker}</CardKicker>
        <h2 className="text-heading-sm text-fg">{ptBR.laudoCaso.notReadyTitle}</h2>
        <p className="max-w-xl text-body-sm text-fg-muted">{ptBR.laudoCaso.notReadyBody}</p>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={onBack}
          data-testid="laudo-back-to-workspace"
        >
          {ptBR.laudoCaso.backToWorkspace}
        </Button>
      </Blueprint>
    </article>
  );
}
